export const getUtmParameters = (searchParams?: URLSearchParams) => {
    const params = searchParams || new URLSearchParams(window.location.search);

    // Helper function to get the last value of a parameter when duplicated
    const getLastParam = (paramName: string) => {
        const allValues = params.getAll(paramName);
        return allValues.length > 0 ? allValues[allValues.length - 1] : null;
    };

    // Try to get UTM from URL first - get last value for each parameter
    const urlUtm = {
        utm_campaign: getLastParam('utm_campaign'),
        utm_source: getLastParam('utm_source'),
        utm_medium: getLastParam('utm_medium'),
        utm_term: getLastParam('utm_term'),
        utm_content: getLastParam('utm_content')
    };

    const hasUrlUtm = Object.values(urlUtm).some(value => value !== null);

    if (hasUrlUtm) {
        return {
            utm_campaign: urlUtm.utm_campaign || 'none',
            utm_source: urlUtm.utm_source || 'none',
            utm_medium: urlUtm.utm_medium || 'none',
            utm_term: urlUtm.utm_term || 'none',
            utm_content: urlUtm.utm_content || 'none'
        };
    }

    // No UTM in URL, try localStorage
    const storedUtm = localStorage.getItem('wallarm_utm_data');
    if (storedUtm) {
        try {
            const parsedUtm = JSON.parse(storedUtm);
            if (parsedUtm && typeof parsedUtm === 'object') {
                return {
                    utm_campaign: parsedUtm.utm_campaign || 'none',
                    utm_source: parsedUtm.utm_source || 'none',
                    utm_medium: parsedUtm.utm_medium || 'none',
                    utm_term: parsedUtm.utm_term || 'none',
                    utm_content: parsedUtm.utm_content || 'none'
                };
            }
        } catch (e) {
            localStorage.removeItem('wallarm_utm_data');
        }
    }

    return {
        utm_campaign: 'none',
        utm_source: 'none',
        utm_medium: 'none',
        utm_term: 'none',
        utm_content: 'none'
    };
};

export const getOriginalSource = (): string => {
    const stored = localStorage.getItem('wallarm_original_source');
    if (stored) {
        return stored;
    }

    const originalSource = document.referrer || window.location.href;

    localStorage.setItem('wallarm_original_source', originalSource);

    return originalSource;
};

export const getTrackingData = () => ({
    ...getUtmParameters()
});
